import React from 'react';
import './ViewClassSession.css';
import play from '../../Assets/play.png';
import { useNavigate } from 'react-router-dom';
import { ShoppingCartOutlined } from '@ant-design/icons';

function ViewClassSession({ progress }) {
  const navigate = useNavigate();

  const handleViewClass = () => {
    navigate('/class');
  };

  return (
    <div className='view-class-container'>
      <div className="class-image" onClick={handleViewClass}>
        <img src={play} alt="play" className="play-toggle" />
      </div>

      <div className='view-class-details'>
        <div className='teacher-price'>
          <span className='teacher-name'>Edison Matheus</span>
          <span className='price-value'>Tsh 45,000</span>
        </div>

        <p className='class-view-title'>Mastering Illustration: Sketching, Inking & Color Essentials</p>
        <div className='teacher-price'>
            <div className='class-view-watch'>
            </div>
            <ShoppingCartOutlined  className='shopping-view-icon'/>
        </div>
      </div>
    </div>
  );
}

export default ViewClassSession;
